const decayList = [{ value: 0.007, name: '0.7%' }, { value: 0.01, name: '1%' }];
export default decayList;
